import React from 'react';

const JS_Classes = () => {
  return (
    <div >
      <h1>JS_Classes</h1>
      <p>Placeholder component for: "JS Classes"</p>
    </div>
  );
};

export default JS_Classes;
